import { helpCenterViewHomePageExperienceId } from '@atlassian/help-center-common-util/analytics/ufo/ufo';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

export const helpCenterViewHomePageExperience = new UFOExperience(
	helpCenterViewHomePageExperienceId,
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);
